import React, { useRef } from 'react';
import styles from './index.module.scss';
export default (props) => {
    const { visible, hideModal, content, containerStyle, isClosedByClick = true } = props;
    const contentRef = useRef(null);
    const onModalClick = (e) => {
        // 如果点击内容外侧则关闭，点击内容则不会关闭
        if (contentRef.current.contains(e.target)) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        isClosedByClick && hideModal();
    };
    if (!visible)
        return React.createElement("div", null);
    return (React.createElement("div", { className: styles['modal'], style: Object.assign({ display: visible ? 'flex' : 'none' }, containerStyle), onClick: onModalClick },
        React.createElement("div", { className: styles.content, ref: contentRef }, content)));
};
